"use strict";

var _classCallCheck = require("/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RawTask =
/*#__PURE__*/
function () {
  _createClass(RawTask, [{
    key: "call",
    value: function call() {
      try {
        this.task && this.task();
      } catch (error) {
        this.onError(error);
      } finally {
        this.task = null;
        this.release(this);
      }
    }
  }]);

  function RawTask(onError, release) {
    _classCallCheck(this, RawTask);

    this.onError = onError;
    this.release = release;
    this.task = null;
  }

  return RawTask;
}();

exports.RawTask = RawTask;